
import { Component, ElementRef } from '@angular/core';
import * as moment from 'moment';
import { PageBase } from 't4core';
@Component({
    styleUrls: ['./TotalReport.css'],
    selector: 'TotalReport',
    templateUrl: './TotalReport.component.html',
})
export class TotalReportComponent extends PageBase {
    private _from: moment.Moment = this.now.clone().startOf('day');
  private _to: moment.Moment = this.now.clone().endOf('day');
    public queryParameters: any = { from: this._from.format("YYYY-MM-DDTHH:mm:ss[Z]"), to: this._to.format("YYYY-MM-DDTHH:mm:ss[Z]"), reportName: "RentalReport" };

    public get from(): moment.Moment { return this._from; }
    public set from(val: moment.Moment) {
        if (this._from != val) {
            this._from = val;
          this.queryParameters = { from: this._from.format("YYYY-MM-DDTHH:mm:ss[Z]"), to: this._to.format("YYYY-MM-DDTHH:mm:ss[Z]"), reportName: "RentalReport" };
        }
    }

    public get to(): moment.Moment { return this._to; }
    public set to(val: moment.Moment) {
        if (this._to != val) {
            this._to = val;
          this.queryParameters = { from: this._from.format("YYYY-MM-DDTHH:mm:ss[Z]"), to: this._to.format("YYYY-MM-DDTHH:mm:ss[Z]"), reportName: "RentalReport" };
        }
    }

    public updateParams() {
      this.queryParameters = { from: this._from.format("YYYY-MM-DDTHH:mm:ss[Z]"), to: this._to.format("YYYY-MM-DDTHH:mm:ss[Z]"), reportName: "RentalReport" };
    }

    constructor(el: ElementRef) {
        super(el, "TotalReport");
    }
}
